import { render, staticRenderFns } from "./ed-members-connected-list.component.vue?vue&type=template&id=0ec06fb4&scoped=true&"
import script from "./ed-members-connected-list.component.ts?vue&type=script&lang=ts&"
export * from "./ed-members-connected-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-members-connected-list.component.scss?vue&type=style&index=0&id=0ec06fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec06fb4",
  null
  
)

export default component.exports